import * as Promise from 'bluebird';

export function generateID(): string {
    // Creates a random string which looks like a UUID
    const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    return (`${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`);
}

export function execScript(url: string): Promise<any> {
    const script = document.createElement('script'),
        head = document.getElementsByTagName('head')[0];

    let done = false;

    return new Promise(resolve => {
        script.src = url;
        script.onload = (script as any).onreadystatechange = function () {
            if (!done && (!this.readyState ||
                this.readyState === 'loaded' || this.readyState === 'complete')) {
                done = true;

                resolve();

                // IE memory leak
                script.onload = () => (script as any).onreadystatechange = null;
                head.removeChild(script);
            }
        };
        head.appendChild(script);
    });
}

export function isEmptyObject(obj: object): boolean {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/utils.ts